import request from '@/utils/request'

// 配置列表
// 入参  page: number;
// page_size: number;
// type?: number;  查询参数
export function configsList(params) {
  return request({
    url: `/environment/variable_configs/index`,
    method: 'get',
    params
  })
}

// 创建配置
// 入参  config: array[string];必需
// type: number;必需
export function createConfig(data = {}) {
  return request({
    url: '/environment/variable_configs/create',
    method: 'post',
    data
  })
}

// 更新配置
// 入参 id integer 必需
// config array[string] 必需

export function updateConfig(data = {}) {
  return request({
    url: '/environment/variable_configs/update',
    method: 'post',
    data
  })
}

// 结构体-场景值列表
export function typeList(params) {
  return request({
    url: `/environment/variable_struct/typeList`,
    method: 'get',
    params
  })
}

// 结构体详情
export function vsDetail(params) {
  return request({
    url: `/environment/variable_struct/detail`,
    method: 'get',
    params
  })
}

// 创建结构体
// 入参  struct: string[];
// type: number;
export function vsCreate(data = {}) {
  return request({
    url: '/environment/variable_struct/create',
    method: 'post',
    data
  })
}

// 更新结构体
// 入参  struct: string[];
// type: number;
export function vsUpdate(data = {}) {
  return request({
    url: '/environment/variable_struct/update',
    method: 'post',
    data
  })
}
